import { useEffect, useState } from "react";
import { Globe, FlaskConical } from "lucide-react";
import { getLiveStatus } from "@/lib/api";

let cached = null;

export function useLive() {
  const [live, setLive] = useState(cached);
  useEffect(() => {
    if (cached) return;
    getLiveStatus().then((s) => { cached = s; setLive(s); });
  }, []);
  return live;
}

export function LiveBadge({ live, testid }) {
  if (!live) return null;
  return live.live ? (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 text-[0.65rem] uppercase tracking-wide px-2 py-1 rounded-full border border-emerald-800/60 text-emerald-400">
      <Globe size={11} /> Dati del sito live
    </span>
  ) : (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 text-[0.65rem] uppercase tracking-wide px-2 py-1 rounded-full border border-[#3A4763] text-neutral-400">
      <FlaskConical size={11} /> Dati di prova (preview)
    </span>
  );
}
